<template>
  <div class="examarrangement">
    <el-header style="height:40px;">
      <el-page-header @back="goBack" content="成绩详情">
      </el-page-header>
    </el-header>
    <div class="contents">
      <div class="firstdiv">

        <!-- <div class="teachername">发布老师：<span>{{taskmessage.teacher_name}}</span></div> -->
<!--        <template  v-if="task_id>30||task_id==22">-->
<!-- <div class="teachername" v-for="item in  taskmessage.score">分数：<span>{{item}}</span></div>-->
<!--        </template>-->
        <div class="teachername">分数：<span>{{taskmessage.score}}</span></div>

      </div>

      <div class="twodiv">

        <div class="itemdiv">
          <div class="tit">学生描述:</div>
          <div class="condiv" v-if="type==1">
            <el-table :data="tabledata" style="width:400px">
              <el-table-column prop="dian" label="考核点">
              </el-table-column>
              <el-table-column prop="score" label="得分">
              </el-table-column>

            </el-table>
          </div>
          <div class="condiv" v-else>
            {{taskmessage.student_des}}
          </div>
        </div>
        <div class="itemdiv">
          <div class="tit">学生答案:</div>
          <div class="condiv">

            <img :src="GLOBAL.BASE_URL+item" alt="" v-for="item in taskmessage.student_answer" class="imglist">
          </div>
        </div>
        <div class="itemdiv">
          <div class="tit">老师批复:</div>
          <div class="condiv">
            <img :src="GLOBAL.BASE_URL+item" alt="" v-for="item in taskmessage.teacher_answer" class="imglist">
          </div>
        </div>
        <div class="itemdiv">
          <div class="tit">老师评论:</div>
          <template  v-if="task_id>30">
          <div class="condiv" v-for="item in  taskmessage.teacher_comment">
            {{item}}
          </div>
          </template>
            <div class="condiv" v-else>
            {{taskmessage.teacher_comment}}
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  props: {

  },
  data() {
    return {

      // 分页插件
      pageform: {
        total: 0,
        pages: 5,  // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 9, // 每页显示条目个数
      },
      params: {
        class_id: this.$store.getters.getUserInfo.class_id,
        page_size: 9,
        page: 1
      },
      task_id: '',
      taskmessage: '',
      tabledata: [],
      type: ''
    };
  },
  computed: {

  },
  created() {
    this.task_id = this.$route.query.task_id
    this.type = this.$route.query.type
    this.gettaskstatus()
  },
  methods: {
    //作业状态
    gettaskstatus() {
      this.$http.taskstatus({ task_id: this.task_id })
        .then(res => {
          if (res.code == 200) {
            if (res.data) {
              this.taskmessage = res.data
               if(this.task_id>30){
 this.taskmessage.teacher_comment = JSON.parse(this.taskmessage.teacher_comment)
             }
  //              if(this.task_id>30||this.task_id==22){
  // this.taskmessage.score = JSON.parse(this.taskmessage.score)
  //            }
             if(this.taskmessage.student_des){
 var arr = this.taskmessage.student_des.slice(1, this.taskmessage.student_des.length);
              var arr1 = []
              for (var i = 0; i < arr.length; i++) {
                var obj = {
                  dian: '',
                  score: ''
                }
                obj.dian = arr[i][0]
                obj.score = arr[i][1]
                arr1.push(obj)
              }
              this.tabledata = arr1
             }

            } else {
            }

          } else {

            this.$message.error(res.message)
          }

        })
    },
    goBack() {
      this.$router.back()
    },
  },
};
</script>

<style  lang="less">
.examarrangement {
  .contents {
    padding: 20px;
 background: #f9f9f9;
     overflow: hidden;
  }
  .firstdiv {
    overflow: hidden;
    div {
      width: 25%;
    }
    .taskname {
      float: left;
      color: #5193f7;
      font-size: 16px;
      font-weight: bold;
    }
    .teachername {
      color: #303133;
      // font-size: 16px;
      float: left;
        font-size: 14px;
      font-weight: bold;
      span{
         font-weight: normal;
      }
    }
  }
  .twodiv {
    padding-top: 20px;
    overflow: hidden;
.itemdiv{
  margin-bottom: 10px;
}
    .tit {
      margin-bottom: 6px;
      font-size: 14px;
      font-weight: bold;
    }
    // width: 33.33%;
    width: 100%;
    float: left;
    .condiv {
      padding-right: 10px;
      overflow: hidden;
    }
    .imglist {
      height: 400px;
      float: left;
      margin-left: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assessment/examarrangement.vue